import type { AchievementTier } from '@scrambl/shared'

/** CSS color values for a badge tier (tokens in styles/colors.css). */
export function tierColors(tier: AchievementTier): {
  ring: string
  disc: string
  ink: string
} {
  return {
    ring: `hsl(var(--badge-${tier}))`,
    disc: `hsl(var(--badge-${tier}-soft))`,
    ink: `hsl(var(--badge-${tier}-ink))`,
  }
}

export const TIER_LABEL: Record<AchievementTier, string> = {
  bronze: 'Bronze',
  silver: 'Silver',
  gold: 'Gold',
}
